import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { usePeriscopeMetadata } from '@hooks';
import { MetadataContainer } from '@periscopes/general/metadata';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';
export const PardotEmailTemplateMetadataTab = ({ sonarObjectId }) => {
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.PardotEmailTemplate);
    const metadataEntries = useMemo(() => {
        if (!metadata) {
            return [];
        }
        const entries = [
            {
                label: COPY_SPECIFIC.SUBJECT,
                type: 'string',
                value: metadata.subject
            },
            {
                label: COPY_SPECIFIC.PUBLISHED,
                type: 'boolean',
                value: metadata.published
            },
            {
                label: COPY_SPECIFIC.SENDER,
                type: 'array',
                value: metadata.sender
            },
            {
                label: COPY_SPECIFIC.REPLY_TO,
                type: 'array',
                value: metadata.replyTo
            }
        ];
        return entries;
    }, [metadata]);
    if (loading) {
        return React.createElement(LoadingSpinner, null);
    }
    return React.createElement(MetadataContainer, { entries: metadataEntries, title: COPY_SPECIFIC.EMAIL_TEMPLATE_INFORMATION });
};
